var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M23,0H1C0.447,0,0,0.447,0,1v1c0,1.654,1.346,3,3,3h8v3.059C6.507,8.558,3,12.375,3,17v6 c0,0.553,0.447,1,1,1h16c0.553,0,1-0.447,1-1v-6c0-4.625-3.507-8.442-8-8.941V5h8c1.654,0,3-1.346,3-3V1C24,0.447,23.553,0,23,0z M15,16c0,1.657-1.343,3-3,3s-3-1.343-3-3s1.343-3,3-3S15,14.343,15,16z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }